import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

const ModalComponent = ({
  open,
  onClose,
  onConfirm,
  title,
 confirmBtn
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="logout-dialog-title"
      aria-describedby="logout-dialog-description"
      PaperProps={{
        style: {
          borderRadius: 16,
          padding: '24px 32px',
          minWidth: 480,
          border: '2px solid #3f51b5',
        },
      }}
    >
      <DialogTitle
        id="logout-dialog-title"
        style={{
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '22px',
          color: '#3f51b5',
        }}
      >
        Confirm
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          id="logout-dialog-description"
          style={{
            textAlign: 'center',
            fontSize: '18px',
            color: '#444',
            padding: '12px 0 24px',
            fontWeight: 500,
          }}
        >
          {title}
        </DialogContentText>
      </DialogContent>

      <DialogActions
        style={{
          justifyContent: 'center',
          gap: 20,
          paddingBottom: 24,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          style={{
            fontSize: '15px',
            padding: '8px 20px',
            borderColor: '#3f51b5',
            color: '#3f51b5',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#3f51b5';
            e.target.style.color = '#fff';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = '#3f51b5';
          }}
        >
          No
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          style={{
            backgroundColor: '#d32f2f',
            color: '#fff',
            fontSize: '15px',
            padding: '8px 20px',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#b71c1c';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#d32f2f';
          }}
        >
          {confirmBtn}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalComponent;
